module.exports = __webpack_public_path__ + "arrow-right-fxS.svg";